<template>
    <div class="tree-container">
        <div class="page-mode-input-wrapper">
            <div class="page-mode-input">
                <el-input v-model="searchVal" placeholder=""></el-input>
            </div>
            <div class="input-btn" @click="handleSearch">
                <i class="el-icon-search input-btn-icon"></i>
                <span class="input-btn-label">搜索</span>
            </div>
        </div>
        <div class="tree-wrapper">
            <div v-for="(item, key) in treeData" :key="'tree-' + key" class="tree-model">
                <div class="tree-title" @click="handleFirstTitle(item)">
                    <div class="tree-icon">
                        <i :class="item.show ? 'el-icon-caret-right tree-item-icon' : 'el-icon-caret-right'"></i>
                        <img src="../assets/img/file.png" alt="" class="tree-img">
                    </div>
                    <div class="tree-label-wrapper">
                        <div class="tree-label">{{ item.deptName }}</div>
                        <div class="tree-num">({{ item.memberCount }})</div>
                    </div>
                </div>
                <div v-if="item.show" class="tree-mode-content">
                    <div v-for="(childItem, childKey) in item.children" :key="'childTree-' + childKey">
                        <div class="tree-title tree-gap" @click="handleSecondTitle(item, childItem)">
                            <div class="tree-icon">
                                <i
                                    :class="childItem.show ? 'el-icon-caret-right tree-item-icon' : 'el-icon-caret-right'"></i>
                                <img src="../assets/img/file.png" alt="" class="tree-img">
                            </div>
                            <div class="tree-label-wrapper">
                                <div class="tree-label-child">{{ childItem.deptName }}</div>
                                <div class="tree-num">({{ childItem.memberCount }})</div>
                            </div>
                        </div>
                        <div v-if="childItem.show" class="tree-mode-content">
                            <div v-for="(grandItem, grandKey) in childItem.children" :key="'grandTree-' + grandKey">
                                <div class="tree-title tree-gap-child"
                                    @click="handleThirdTitle(item, childItem, grandItem)">
                                    <div class="tree-icon">
                                        <img src="../assets/img/file.png" alt="" class="tree-img">
                                    </div>
                                    <div class="tree-label-wrapper">
                                        <div class="tree-label-grandChild">{{ grandItem.deptName }}</div>
                                        <div class="tree-num">({{ grandItem.memberCount }})</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { getOrganizationalStructure } from '@/api/index.js';
export default {
    name: '',
    props: {
        updateModel: {
            type: Number
        }
    },
    components: {

    },
    data() {
        return {
            dept: '',
            token: '',
            searchVal: "",
            treeData: []
        }
    },
    watch: {
        updateModel: function (val, oldVal) {
            this.getOrgStructure();
        }
    },
    created() {
        this.token = localStorage.getItem('token');
        this.dept = localStorage.getItem('dept');
        // this.dept = this.$route.params.dept;
        // this.token = this.$route.params.token;
    },
    mounted() {
        this.getOrgStructure();
    },
    methods: {
        getOrgStructure() {
            getOrganizationalStructure({
                keyword: this.searchVal
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.resetData(data.deptList);
                }
                return;
            }).catch(err => {
             //   console.log(err);
            });
        },
        emitDefault(data) {
            var row = data[0];
            this.$emit('deptRow', JSON.stringify(row));
        },
        resetData(data) {
            for (var i = 0; i < data.length; i++) {
                var item = data[i];
                if (i == 0) {
                    data[i]["show"] = true;
                } else {
                    data[i]["show"] = false;
                }
                data[i]["level"] = 0;
                var childContent = item.children;
                if (childContent && childContent != null) {
                    for (var j = 0; j < childContent.length; j++) {
                        childContent[j]["show"] = false;
                        childContent[j]["level"] = 1;
                        var grandChild = childContent[j]["children"];
                        if (grandChild && grandChild != null) {
                            for (var k = 0; k < grandChild.length; k++) {
                                grandChild[k]["show"] = false;
                                grandChild[k]["level"] = 2;
                                if (k == grandChild.length - 1) {
                                    childContent[j]["children"] = grandChild;
                                }
                            }
                        }
                        if (j == childContent.length - 1) {
                            data[i]["children"] = childContent;
                        }
                    }
                }
                if (i == data.length - 1) {
                    this.treeData = data;
                    this.emitDefault(data);
                }
            }
        },
        handleFirstTitle(row) {
            this.$emit('deptRow', JSON.stringify(row));
            var status = row.show;
            var treeData = this.treeData;
            for (var i = 0; i < treeData.length; i++) {
                var item = treeData[i];
                if (item.deptId == row.deptId) {
                    treeData[i]["show"] = !status;
                }
                if (i == treeData.length - 1) {
                    this.treeData = treeData;
                }
            }
        },
        handleSecondTitle(row, childRow) {
            this.$emit('deptRow', JSON.stringify(childRow));
            var status = childRow.show;
            var treeData = this.treeData;
            var newArr = [];
            for (var i = 0; i < treeData.length; i++) {
                var item = treeData[i];
                if (item.deptId == row.deptId) {
                    var childContent = item.children;
                    for (var j = 0; j < childContent.length; j++) {
                        var childItem = childContent[j];
                        if (childItem.deptId == childRow.deptId) {
                            childContent[j]["show"] = !status;
                        }
                        if (j == childContent.length - 1) {
                            newArr.push(item);
                        }
                    }
                } else {
                    newArr.push(item);
                }
                if (i == treeData.length - 1) {
                    this.treeData = treeData;
                }
            }
        },
        handleThirdTitle(row, childRow, grandItem) {
            this.$emit('deptRow', JSON.stringify(grandItem));
            //console.log(row,childRow,grandItem);
        },
        handleSearch() {
            this.getOrgStructure();
        }
    }
}
</script>

<style scoped>
.tree-container {
    width: 100%;
    height: 100%;
    background: linear-gradient(141deg, #4A6BEA 0%, #7995FF 100%);
    border-radius: 6px 6px 0px 0px;
    display: flex;
    flex-direction: column;
    animation: animi 1s;

    overflow-x: hidden;
}

.tree-wrapper {
    margin: 36px 24px 36px 24px;
    color: #fff;
    flex: 1;
}

.tree-title {
    display: flex;
    flex-wrap: nowrap;
    margin-bottom: 13px;
}

.tree-title:hover {
    cursor: pointer;
    opacity: 0.8;
}

.tree-gap {
    margin-left: 15px;
}

.tree-gap-child {
    margin-left: 30px;
}

.tree-label-wrapper {
    flex: 1;
    display: flex;
}

.tree-label {
    width: 180px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    margin-left: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.tree-label-child {
    width: 165px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    margin-left: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.tree-label-grandChild {
    width: 150px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    margin-left: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.tree-mode-content {
    animation: animi .5s;
}

.tree-icon {
    position: relative;
    top: 3px;
    width: 38px;
}

.tree-item-icon {
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    transform: rotate(90deg);
}

.tree-img {
    width: 15px;
    height: 15px;
    margin-left: 2px;
}

.tree-num {
    position: relative;
    top: 3px;
}

.page-mode-input-wrapper {
    display: flex;
    width: 235px;
    position: relative;
    top: -5px;
    margin: 0 auto;
    margin-top: 36px;
}

.page-mode-input>>>.el-input__inner {
    width: 160px !important;
    height: 38px !important;
    border-radius: 6px 0px 0px 6px !important;
    border: 1px solid #fff !important;
    border-right: 0px !important;
    background: transparent;
    color: #fff;
}

.input-btn {
    width: 75px;
    height: 38px;
    background: #fff;
    border-radius: 0px 6px 6px 0px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4F79ED;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.input-btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.input-btn-icon {
    font-size: 13px;
}

.input-btn-label {
    margin-left: 5px;
}

/* .el-tree-node__label{
    
} */
</style>


